var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRadioActive = function SvgRadioActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.19.2-Configuration-/-Package-/-Create-new---step-1--default-(General)",
    transform: "translate(-688.000000, -177.000000)",
    stroke: "#AD5E99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-all-doc-/-Lifestyle-survey",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(0.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#AD5E99",
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    rx: 7.5
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRadioActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/radio-active.ab07fae1.svg";
export { ForwardRef as ReactComponent };